// @flow

// Effect Managers
import { take, put, select, call } from 'redux-saga/effects'

// Constants
import { SELECT_SOIL_JOB } from 'hfty-soil-jobs-dom/src/constants'
import {
  PROP_STATUS,
  RESULTS_POSTED,
  PROP_FIELD,
} from 'hfty-model-soil-jobs'

// Actions
import { loadSoilPropsMapData } from 'hfty-map-dom'

// Selectors
import { selectedJob } from 'hfty-soil-jobs/src/selectors/selectedJob'

// Controllers
import jobsCtrl from 'fc-ctrl-sampling-jobs'
import soilTestResultsCtrl from 'fc-ctrl-soil-test-results'

export default function *watchSelectedJob (): Generator<*, *, *> {
  while (true) {
    const { payload } = yield take(SELECT_SOIL_JOB)
    let jobObject = yield select(selectedJob(payload))

    while (!jobObject) {
      yield take(jobsCtrl.actionTypes.receive())
      jobObject = yield select(selectedJob(payload))
    }

    if (jobObject[PROP_STATUS] === RESULTS_POSTED) {
      const queryParams = {
        rootAsset: jobObject[PROP_FIELD],
      }
      yield call(soilTestResultsCtrl.get, { queryParams })
      yield put(loadSoilPropsMapData(jobObject.field))
    }
  }
}
